export const COMM_CHANNELS = [
  { value: "whatsapp", label: "WhatsApp" },
  { value: "messenger", label: "Messenger" },
  { value: "viber", label: "Viber" },
  { value: "telegram", label: "Telegram" },
  { value: "other", label: "Altele / Egyéb / Other" },
];

export const CURRENCIES = ["EUR", "RON", "USD", "HUF"];
export const CURRENCY_LABEL = { EUR: "EUR (€)", RON: "RON (Lei)", USD: "USD ($)", HUF: "HUF (Ft)" };
